import React from 'react';
import { RefreshIcon } from '@avila-tek/ui/src';
import { Company } from '../../../models';
import SearchInput from '../../shared/SearchInput';

interface CatalogueFiltersProps {
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  allies: Company[];
  selectedAlly: string;
  setSelectedAlly: React.Dispatch<React.SetStateAction<string>>;
  searchWithText: (text: string) => Promise<void>;
}

function CatalogueFilters({
  searchText,
  setSearchText,
  allies,
  selectedAlly,
  setSelectedAlly,
  searchWithText,
}: CatalogueFiltersProps) {
  const classNameSelected =
    'border  border-purple-300 text-purple-300 bg-purple-50';
  const classNameNotSelected = 'bg-neutral-warm-200 text-text-gray';

  return (
    <div className="flex flex-col xl:flex-row justify-between gap-5">
      <div className="flex gap-5 flex-col sm:flex-row flex-wrap ">
        <button
          type="button"
          className={`py-2 px-4 rounded ${
            selectedAlly === '' ? classNameSelected : classNameNotSelected
          } `}
          onClick={() => {
            setSelectedAlly('');
          }}
        >
          Ver todo
        </button>
        {allies.map((ally) => (
          <button
            type="button"
            className={`py-2 px-4 rounded ${
              selectedAlly === ally?._id
                ? classNameSelected
                : classNameNotSelected
            }`}
            onClick={() => {
              setSelectedAlly(ally._id);
            }}
          >
            {ally?.name}
          </button>
        ))}
      </div>
      <div>
        <SearchInput
          searchText={searchText}
          setSearchText={setSearchText}
          action={() => searchWithText(searchText)}
          className="sm:w-64"
        />
      </div>
      <div>
        <RefreshIcon
          className=" text-purple-300 mt-2 "
          onClick={() => {
            searchWithText('');
            setSelectedAlly('');
          }}
        />
      </div>
    </div>
  );
}

export default CatalogueFilters;
